/** Banner copy for parachute payment sub-steps (shared by severance / CIC / comp / equity UI). */
export const PARACHUTE_STEP_INFO = {
  cicBonus:
    'Change-in-control bonus amounts treated as parachute payments for the Section 280G threshold and excise tax analysis.',
  compIncreases:
    'Compensation increases within 12 months of the transaction may be presumed parachute payments under Q&A-25.',
  equity: 'Equity award acceleration and valuation (including Q&A-24(c)) for disqualified individuals at closing.',
};

/** Plain body after the “Present Value:” label — Severance banner (Q&A-31/32). */
export function getSeverancePresentValueNoteBody(formData?: { afr?: number | string }) {
  const afr = Number(formData?.afr) || 5;
  return `Per Q&A-31/32, future payments are discounted using 120% of the AFR (${afr}% → ${(afr * 1.2).toFixed(2)}%) compounded semiannually. "Paid over time" assumes monthly payments starting at closing. For purposes of this analysis, termination is assumed to occur on the closing date.`;
}
